<app-orders-nav [activeMenuItem]="'orders'"></app-orders-nav>


<div *ngIf="!currentUserIsPartner() && this.ultimatelyFailedOrdersCount && this.ultimatelyFailedOrdersCount > 0" class="content-card">

  <div style="min-height: 40px; padding-left: 15px; padding-top: 25px; background-color: yellow; color: red;">
    There
    <ng-container *ngIf="ultimatelyFailedOrdersCount == 1">is</ng-container><ng-container *ngIf="ultimatelyFailedOrdersCount > 1">are</ng-container> {{ ultimatelyFailedOrdersCount }} order status changes that failed more than 10 times. Check necessary.
  </div>

</div>

<!--<ng-container *ngIf="!currentUserIsPartner()">
  <div class="header" fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="20px" style="padding: 8px 10px;">
    <div fxFlex="20" (click)="goToConversionsQueued()" style="cursor:pointer;">
      <mat-card style="margin-left: 0;">
        <h3 style="margin-top: 0; margin-bottom: 0">{{cardsQueuedForConversionLength$ | async}}</h3>
        <span style="font-size: .8em">Cards queued for conversion</span>
      </mat-card>
    </div>
    <div fxFlex="20" (click)="goToExportOrders()" style="cursor:pointer;">
      <mat-card style="margin-left: 0;">
        <h3 style="margin-top: 0; margin-bottom: 0">{{exportableOrdersCount$ | async}}</h3>
        <span style="font-size: .8em">Orders to export</span>
      </mat-card>
    </div>
    <div fxFlex="20" (click)="goToExtensionsQueued()" style="cursor:pointer;">
      <mat-card style="margin-left: 0;">
        <h3 style="margin-top: 0; margin-bottom: 0">{{cardsQueuedForExtensionLength$ | async}}</h3>
        <span style="font-size: .8em">Cards queued for extension</span>
      </mat-card>
    </div>
    <div fxFlex="20" (click)="goToReferrals()">
      <mat-card style="margin-left: 0;">
        <h3 style="margin-top: 0; margin-bottom: 0">{{referralsPendingBonusCount$ | async}} / {{referralsOverallCount$ | async}}</h3>
        <span style="font-size: .8em">Referrals bonus / overall</span>
      </mat-card>
    </div>
  </div>
</ng-container>-->

<mat-card class="content-card">

  <div class="header" fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="20px">
    <div fxLayoutGap="7px">
      <button mat-raised-button color="primary" [matMenuTriggerFor]="menu">
        Upload
      </button>
      <mat-menu #menu="matMenu">
        <a mat-menu-item routerLink="import">
          <mat-icon>add_shopping_cart </mat-icon><span>Upload orders</span>
        </a>
        <a mat-menu-item *appHasRoles="['admin', 'manager', 'agent', 'compliance', 'compliance']" routerLink="card-creation-import">
          <mat-icon>assignment_returned </mat-icon><span>Upload card creations</span>
        </a>
        <a mat-menu-item *appHasRoles="['admin', 'manager', 'agent']" routerLink="card-activation-import">
          <mat-icon>assignment_turned_in</mat-icon><span>Upload card activations</span>
        </a>
      </mat-menu>
      <button
        *appHasRoles="['admin']"
        mat-raised-button
        color="accent"
        [disabled]="table.selection.isEmpty()"
        (click)="exportOrdersToPortal()">Export</button>
      <button
        *appHasRoles="['admin']"
        mat-raised-button color="blue"
        [disabled]="!dataSource.data"
        (click)="exportAllOrdersView()">Portal Export
      </button>
    </div>
    <div>
      <div fxLayout="row wrap" *ngIf="!currentUserIsPartner()">
        <mat-button-toggle-group>
          <mat-button-toggle checked #allButton
                             class="mat-b-toggle-thin"
                             (click)="filterOrdersByProvenience(0)"
                             value="0">
            <label class="label-for-mat-toggle-button">All</label></mat-button-toggle>
          <mat-button-toggle class="mat-b-toggle-thin" (click)="filterOrdersByProvenience(1)"><label
            class="label-for-mat-toggle-button">Individual</label></mat-button-toggle>
          <mat-button-toggle class="mat-b-toggle-thin" (click)="filterOrdersByProvenience(2)"><label
            class="label-for-mat-toggle-button">Bulk</label></mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div fxLayout="row wrap" *ngIf="!currentUserIsPartner()">
        <mat-button-toggle-group #multiButton
                                 multiple="true"
                                 #group="matButtonToggleGroup"
                                 (change)="groupTest(group.value)">
          <mat-button-toggle #createdButton
                             class="mat-b-toggle-thin"
                             [value]="orderStatus.Created">
            <label class="label-for-mat-toggle-button">New</label>
          </mat-button-toggle>
          <mat-button-toggle #inProductionButton
                             class="mat-b-toggle-thin"
                             [value]="orderStatus.InProduction">
            <label class="label-for-mat-toggle-button">In Production</label>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Additional Status</mat-label>
        <mat-select [formControl]="orderSpecialStatusSelect" (selectionChange)="onWebStatusChange()" multiple>
          <mat-option [value]="'w0'">Ident: Pending</mat-option>
          <mat-option [value]="'w1'">Ident: Success</mat-option>
          <mat-option [value]="'w2'">Ident: Failed</mat-option>
          <mat-option [value]="'cw1'">Customer Ident: Success</mat-option>
          <mat-option [value]="'reorder'">Card Re-Order</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="table" fxLayoutAlign="end center">

        <mat-form-field class="brand-filter-field"  *ngIf="!currentUserIsPartner()">
          <mat-select placeholder="Brand filters" [(ngModel)]="table.filters.companiesFilter" multiple>
            <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-date-edit class="date-field" placeholder="Start date" #startDateFilter="ngModel"
                       [(ngModel)]="table.filters.startFilterDate"></app-date-edit>
        <app-date-edit class="date-field" placeholder="End date" #endDateFilter="ngModel"
                       [(ngModel)]="table.filters.endFilterDate"></app-date-edit>

        <mat-form-field class="date-filter-field">
          <mat-select placeholder="Date filters" [(ngModel)]="table.filters.dateFilterCols" multiple>
            <mat-option *ngFor="let dateFilter of dateFiltersList" [value]="dateFilter.name">{{dateFilter.header}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                 [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()"
                [disabled]="startDateFilter.invalid || endDateFilter.invalid">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>

      </div>
    </div>

  </div>

  <app-mat-table-generator #table
    tableName="ordersTable"
    [useEmbededFilter]="false"
    [columns]="columns"
    [dataSource]="dataSource"
    [editEnabled]="editEnabled()"
    [deleteEnabled]="deleteEnabled()"
    [multiselectEnabled]="multiselectEnabled()"
    [viewLink]="getViewLink"
    [editLink]="getEditLink"
    (clearingFilters)="checkAllButton()"
    [dialogRemoveText]="dialogRemoveText"
    [saveFilters]=true>
  </app-mat-table-generator>
</mat-card>
